import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home/Home";

function App() {
  return (
    <BrowserRouter>
      <div className="bg-white text-black min-h-screen">
        {/* <Navbar /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/onboard" element={<Home />} />
        </Routes>
      </div>

    </BrowserRouter>
  );
}


export default App;


